<template>
  <div class="index-mobile-container">
    <!-- 1. 顶部固定搜索栏 -->
    <div class="header-search-bar">
      <img
        src="../../assets/img/logo.png"
        class="header-logo"
        alt="logo"
        @click="handleLogoClick"
      >
      <!-- 使用 el-autocomplete 替换原有的静态搜索框 -->
      <div class="search-input-wrap">
        <el-autocomplete
          v-model="keyword"
          :fetch-suggestions="querySearchAsync"
          placeholder="搜索视频、创作者..."
          prefix-icon="el-icon-search"
          class="custom-search"
          size="small"
          @keyup.enter.native="onSearch"
          @select="handleSelect"
        />
      </div>

      <!-- 右侧用户状态区域 (支持登录判断与下拉菜单) -->
      <div class="user-action-wrap">
        <template v-if="!loginUser">
          <div class="login-text-btn" @click="handleLoginClick">登录</div>
        </template>
        <template v-else>
          <el-dropdown trigger="click" @command="handleUserCommand">
            <div class="user-avatar-wrapper">
              <img :src="loginUser.avatarUrl" class="user-avatar-img" alt="avatar">
            </div>
            <el-dropdown-menu slot="dropdown" class="user-dropdown-menu">
              <div class="user-name-header">{{ loginUser.screenName || '用户' }}</div>
              <el-dropdown-item icon="el-icon-collection" command="background">进入后台</el-dropdown-item>
              <el-dropdown-item icon="el-icon-switch-button" divided @click.native="goToLogout">退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </div>
    </div>

    <!-- 2. 子路由动态挂载区域 -->
    <div id="main-view-container" class="main-view-content">
      <router-view />
    </div>

    <!-- 3. 底部移动端 Tabbar 导航栏 -->
    <div class="bottom-tabbar">
      <div
        class="tabbar-item"
        :class="{ active: currentTab === 'home' }"
        @click="switchTab('home')"
      >
        <i class="el-icon-s-home" />
        <span>主页</span>
      </div>
      <div
        class="tabbar-item"
        :class="{ active: currentTab === 'short' }"
        @click="switchTab('short')"
      >
        <i class="el-icon-video-camera" />
        <span>短视频</span>
      </div>
      <div
        class="tabbar-item"
        :class="{ active: currentTab === 'timeline' }"
        @click="switchTab('timeline')"
      >
        <i class="el-icon-wind-power" />
        <span>动态</span>
      </div>
      <div
        class="tabbar-item"
        :class="{ active: currentTab === 'my' }"
        @click="switchTab('my')"
      >
        <i class="el-icon-s-custom" />
        <span>我的</span>
      </div>
    </div>
  </div>
</template>

<script>
import { userMixin } from 'assets/js/mixin'
import { getUnreadCount } from '@/api/user'
import { keywordSuggest } from '@/api/vod'

export default {
  name: 'IndexMobile',
  mixins: [userMixin],
  data() {
    return {
      currentTab: 'home',
      msgCount: 0,
      keyword: '' // 搜索关键字
    }
  },
  computed: {
    loginUser() {
      return this.$store.state.userInfo
    }
  },
  watch: {
    '$route'(to) {
      this.updateActiveTab(to.path)
    },
    loginUser: {
      handler(newVal) {
        if (newVal) {
          getUnreadCount().then(resp => {
            if (resp.code === 0) {
              this.msgCount = resp.data.total
            }
          }).catch(err => {
            console.error(err)
          })
        }
      },
      immediate: true
    }
  },
  created() {
    this.updateActiveTab(this.$route.path)
  },
  methods: {
    formatAvatar(url) {
      if (!url) return 'https://via.placeholder.com/40x40/e4e7ed/909399?text=用户'
      if (url.startsWith('//')) {
        return 'https:' + url
      }
      return url
    },
    updateActiveTab(path) {
      if (path === '/' || path === '/home') {
        this.currentTab = 'home'
      } else if (path.includes('user')) {
        this.currentTab = 'user'
      } else {
        this.currentTab = 'other'
      }
    },
    switchTab(tab) {
      this.currentTab = tab
      if (tab === 'home') {
        if (this.$route.path !== '/') this.$router.push('/')
      } else if (tab === 'short') {
        if (this.$route.path !== '/short') this.$router.push('/short')
      } else if (tab === 'timeline') {
        if (this.$route.path !== '/timeline') this.$router.push('/timeline')
      } else if (tab === 'my') {
        const userId = this.loginUser && this.loginUser.userIdStr
        if (userId) {
          this.$router.push(`/my`)
        } else {
          this.$router.push('/login')
        }
      }
    },
    handleLogoClick() {
      if (this.$route.path !== '/') {
        this.$router.push('/')
      }
    },
    querySearchAsync(queryString, cb) {
      if (!queryString) {
        cb([])
        return
      }
      setTimeout(() => {
        keywordSuggest(queryString).then(res => {
          if (res && res.code === 0) {
            const results = (res.data || []).map(item => ({ value: item.keyword }))
            cb(results)
          } else {
            cb([])
          }
        }).catch(() => {
          cb([])
        })
      }, 300)
    },
    handleSelect(item) {
      this.keyword = item.value
      this.onSearch()
    },
    onSearch() {
      if (this.keyword && this.keyword.trim()) {
        this.toSearchPage()
      } else {
        this.$message.warning('搜索内容不能为空！')
      }
    },
    toSearchPage() {
      const query = { keyword: this.keyword.trim(), pn: 1 }
      if (this.$route.path === '/search') {
        this.$router.push({ path: '/search', query }).catch(() => {})
      } else {
        this.$router.push({ path: '/search', query }).catch(() => {})
      }
    },
    handleLoginClick() {
      this.$router.push('/login')
    },
    // 处理下拉菜单点击事件
    handleUserCommand(command) {
      if (command === 'background') {
        this.$router.push('/bg')
      }
    }
  }
}
</script>

<style scoped lang="scss">
.index-mobile-container {
  min-height: 100vh;
  background-color: #f8f9fa;
  padding-top: 50px;
  padding-bottom: 60px;
  box-sizing: border-box;
  user-select: none;
  -webkit-tap-highlight-color: transparent;
}

/* 顶部固定搜索栏 */
.header-search-bar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 50px;
  background-color: #ffffff;
  display: flex;
  align-items: center;
  padding: 0 15px;
  z-index: 100;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);

  .header-logo {
    height: 28px;
    width: auto;
    margin-right: 10px;
    cursor: pointer;
    object-fit: contain;
  }

  .search-input-wrap {
    flex: 1;

    /* 适配 Element UI autocomplete 输入框样式使其完美贴合移动端搜索条 */
    ::v-deep .el-autocomplete {
      width: 100%;

      .el-input__inner {
        background-color: #f1f2f6;
        border: none;
        border-radius: 17px;
        height: 34px;
        line-height: 34px;
        padding-left: 30px;
        color: #303133;
        font-size: 13px;

        &:focus {
          background-color: #ffffff;
          box-shadow: 0 0 0 1px #409eff inset;
        }
      }

      .el-input__prefix {
        left: 6px;
        display: flex;
        align-items: center;
        color: #909399;

        .el-icon-search {
          font-size: 15px;
        }
      }
    }
  }

  .user-action-wrap {
    margin-left: 12px;
    display: flex;
    align-items: center;

    .login-text-btn {
      font-size: 14px;
      color: #409eff;
      font-weight: 500;
      cursor: pointer;
      padding: 4px 8px;
    }

    .user-avatar-wrapper {
      cursor: pointer;
      display: flex;
      align-items: center;

      .user-avatar-img {
        width: 32px;
        height: 32px;
        border-radius: 50%;
        object-fit: cover;
        border: 1px solid #dcdfe6;
      }
    }
  }
}

/* 底部 Tabbar */
.bottom-tabbar {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 55px;
  background-color: #ffffff;
  display: flex;
  justify-content: space-around;
  align-items: center;
  border-top: 1px solid #e4e7ed;
  z-index: 100;

  .tabbar-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 11px;
    color: #909399;
    cursor: pointer;

    i {
      font-size: 20px;
      margin-bottom: 2px;
    }

    &.active {
      color: #409eff;
    }
  }
}
</style>

<style lang="scss">
/* 下拉菜单样式美化 */
.user-dropdown-menu {
  min-width: 140px;
  padding: 6px 0;

  .user-name-header {
    padding: 8px 16px;
    font-size: 13px;
    font-weight: bold;
    color: #303133;
    border-bottom: 1px solid #ebeef5;
    margin-bottom: 4px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .el-dropdown-menu__item {
    font-size: 13px;
    padding: 8px 16px;
  }
}
</style>
